import { ISobAnalyticsReportData } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportData'

import { AcknowledgedStatus } from '../models'

import { ObligatoryFillIn } from './components/filters/inReportToggle'
import { ReportViewModes } from './components/reportViewSelector'
import { ISobAnalyticsFiltersFormData, SubmittedStatus } from './models'

export const QUARTERS_IN_CHART = 8
export const QUARTER = 4

export const SOB_ANALYTICS_GLOBAL_PREFIX = 'Global'

export const SOB_ANALYTICS_INITIAL_FORM_DATA: ISobAnalyticsFiltersFormData = {
  countryCode: [],
  pbmEmail: '',
  managerEmail: '',
  globalPartnerId: [],
  acknowledgedStatus: AcknowledgedStatus.All,
  obligatoryFillIn: ObligatoryFillIn.Planned,
  submittedStatus: SubmittedStatus.All,
  partnerId: [],
  hpPartnerType: '',
  organizations: [],
  products: {
    programType: undefined,
    category: undefined,
    subCategory: undefined,
  },
  partnerTypes: [],
  partnerSpecs: [],
  excludePartnerTypes: [],
  amplifyTrack: [],
  // report view options
  reportViewMode: ReportViewModes.PartnerView,
  reportViewPeriod: undefined,
}

export const SOB_ANALYTICS_INITIAL_DATA: ISobAnalyticsReportData = {
  ReportsEntryId: -1,
  ActualsSyncInfo: [],
  Data: [],
  Partners: [],
  GeoMapping: [],
  Organizations: [],
  PartnerTypes: [],
  PartnerFlags: [],
  ProductHierarchy: [],
  PredefinedFilters: [],
  ListOfPeriods: [],
  DefaultView: [
    {
      ViewId: 'QuarterlyView',
      ViewPeriodTitle: 'FY25 Q1',
    },
  ],
}
